import React from "react";
import { useNavigate } from "react-router-dom";

function LiveChatDemoPage() {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/lives-show");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999999,
        overflowY: "auto",
        background:
          "radial-gradient(circle at top right, rgba(0,242,255,0.24), transparent 30%), radial-gradient(circle at bottom left, rgba(255,0,90,0.18), transparent 32%), #03070d",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <style>
        {`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @keyframes chatMove {
            0% { transform: translateY(120%); }
            100% { transform: translateY(-120%); }
          }

          @keyframes heartFloat {
            0% { transform: translateY(0) scale(1); opacity: 0; }
            20% { opacity: 1; }
            100% { transform: translateY(-190px) scale(1.8); opacity: 0; }
          }

          @keyframes livePulse {
            0%, 100% { box-shadow: 0 0 20px rgba(255,0,90,0.55); }
            50% { box-shadow: 0 0 45px rgba(255,0,90,0.95); }
          }

          .demo-chat-list {
            position: absolute;
            bottom: -40px;
            left: 14px;
            right: 80px;
            animation: chatMove 10s linear infinite;
          }

          .demo-chat-list p {
            margin: 8px 0;
            padding: 9px 12px;
            border-radius: 16px;
            background: rgba(0, 0, 0, 0.42);
            border: 1px solid rgba(0,242,255,0.18);
            color: #d9fbff;
            font-size: 14px;
            text-align: left;
            backdrop-filter: blur(8px);
          }

          .float-heart {
            position: absolute;
            right: 22px;
            bottom: 40px;
            font-size: 30px;
            animation: heartFloat 3s ease-in-out infinite;
          }

          .float-heart.h2 {
            right: 48px;
            animation-delay: 0.7s;
          }

          .float-heart.h3 {
            right: 18px;
            animation-delay: 1.4s;
          }
        `}
      </style>

      <button
        onClick={goBack}
        style={{
          position: "fixed",
          top: 22,
          left: 22,
          zIndex: 10000000,
          padding: "11px 18px",
          borderRadius: 16,
          border: "1px solid rgba(0,242,255,0.45)",
          background: "rgba(0, 12, 20, 0.9)",
          color: "#00f2ff",
          fontWeight: 900,
          cursor: "pointer",
          boxShadow: "0 0 18px rgba(0,242,255,0.25)",
        }}
      >
        ← Retour
      </button>

      <div
        style={{
          minHeight: "100vh",
          padding: "80px 18px 50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: 42,
            margin: "0 0 12px",
            fontWeight: 900,
            textShadow: "0 0 22px rgba(0,242,255,0.75)",
            animation: "fadeUp 0.7s ease forwards",
          }}
        >
          💬 Démo chat en direct
        </h1>

        <p
          style={{
            maxWidth: 760,
            color: "#9befff",
            fontSize: 18,
            lineHeight: 1.6,
            marginBottom: 34,
            animation: "fadeUp 0.9s ease forwards",
          }}
        >
          Simulation d’un live EVO-LIVE avec messages instantanés,
          réactions et interactions spectateurs.
        </p>

        <div
          style={{
            width: "100%",
            maxWidth: 390,
            height: 650,
            borderRadius: 34,
            background:
              "linear-gradient(180deg, rgba(8,22,34,0.95), rgba(2,6,12,0.98))",
            border: "1px solid rgba(0,242,255,0.35)",
            boxShadow: "0 0 45px rgba(0,242,255,0.22)",
            position: "relative",
            overflow: "hidden",
            animation: "fadeUp 1.1s ease forwards",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "radial-gradient(circle at 50% 20%, rgba(0,242,255,0.18), transparent 35%), linear-gradient(180deg, rgba(255,255,255,0.05), transparent)",
            }}
          />

          <div
            style={{
              position: "absolute",
              top: 18,
              left: 18,
              display: "flex",
              alignItems: "center",
              gap: 10,
              zIndex: 2,
            }}
          >
            <span
              style={{
                padding: "7px 12px",
                borderRadius: 999,
                background: "#ff005a",
                color: "#fff",
                fontSize: 12,
                fontWeight: 900,
                animation: "livePulse 1.8s infinite",
              }}
            >
              LIVE
            </span>

            <span
              style={{
                padding: "7px 12px",
                borderRadius: 999,
                background: "rgba(0,0,0,0.45)",
                color: "#d9fbff",
                fontSize: 12,
                border: "1px solid rgba(0,242,255,0.18)",
              }}
            >
              1.2K spectateurs
            </span>
          </div>

          <div
            style={{
              position: "absolute",
              top: 90,
              left: "50%",
              transform: "translateX(-50%)",
              width: 170,
              height: 170,
              borderRadius: "50%",
              background:
                "radial-gradient(circle, rgba(0,242,255,0.24), rgba(0,242,255,0.04), transparent 70%)",
              border: "1px solid rgba(0,242,255,0.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 70,
              boxShadow: "0 0 45px rgba(0,242,255,0.18)",
            }}
          >
            🎥
          </div>

          <div
            style={{
              position: "absolute",
              top: 290,
              left: 22,
              right: 22,
              padding: 16,
              borderRadius: 22,
              background: "rgba(0,0,0,0.28)",
              border: "1px solid rgba(0,242,255,0.16)",
              color: "#9befff",
              fontSize: 14,
              lineHeight: 1.5,
            }}
          >
            Le chat apparaît en temps réel pendant que le live continue.
          </div>

          <div className="float-heart">❤️</div>
          <div className="float-heart h2">🔥</div>
          <div className="float-heart h3">🎁</div>

          <div className="demo-chat-list">
            <p>🔥 Alex : incroyable ce live</p>
            <p>💬 Nina : salut la team EVO</p>
            <p>🎁 Sarah : cadeau envoyé</p>
            <p>❤️ Emma : j’adore l’ambiance</p>
            <p>🚀 Lucas : ça monte fort</p>
            <p>😂 Tom : trop drôle</p>
            <p>💎 Léo : encore un cadeau !</p>
          </div>

          <div
            style={{
              position: "absolute",
              bottom: 18,
              left: 18,
              right: 18,
              height: 46,
              borderRadius: 999,
              background: "rgba(0,0,0,0.55)",
              border: "1px solid rgba(0,242,255,0.22)",
              display: "flex",
              alignItems: "center",
              padding: "0 14px",
              color: "#7ddff0",
              fontSize: 13,
            }}
          >
            Écrire un message...
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveChatDemoPage;
